import styled from 'styled-components';

export const LimitsInfoContainer = styled.div`
  font-size: 13px;
  line-height: 1.6;
  color: #656d7a;
`;
